import { Checkbox } from 'antd';
import '@src/styles/components/customCheckbox.scss';

const CustomCheckbox = ({ className, disabled, ...props }) => {
  return <Checkbox disabled={disabled} checked={disabled} {...props} className={`custom-checkbox ${className}`} />;
};

export default CustomCheckbox;
